export class NoCurrentUserError extends Error {
  constructor (message?: string , options?: ErrorOptions) {
    super(message, options)
    this.name = 'NoCurrentUserError'
  }
}
